import React, { useState } from "react";
import { ArrowRight, Check } from "lucide-react";
import { api } from "../lib/api";

export default function WaitlistForm({ variant = "default" }) {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/waitlist", { email, phone: phone || undefined });
      setDone(true);
    } catch (e) {
      setError(e?.response?.data?.detail || "Couldn't sign up. Try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div data-testid="waitlist-success" className="flex items-center gap-3 text-white">
        <span className="h-9 w-9 grid place-items-center border border-adrenaline text-adrenaline"><Check size={18} /></span>
        <div>
          <div className="text-heading uppercase tracking-wider">You're On The List</div>
          <div className="text-zinc-500 text-mono text-xs uppercase tracking-widest">Check your inbox for confirmation.</div>
        </div>
      </div>
    );
  }

  return (
    <form data-testid="waitlist-form" onSubmit={submit} className="w-full max-w-xl">
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-0 sm:items-stretch border-b border-white/20 focus-within:border-white">
        <input
          data-testid="waitlist-email"
          required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="flex-1 bg-transparent text-white outline-none py-4 placeholder:text-zinc-600 text-base"
        />
        <input
          data-testid="waitlist-phone"
          type="tel" value={phone} onChange={(e) => setPhone(e.target.value)}
          placeholder="+1 (optional)"
          className="bg-transparent text-white outline-none py-4 placeholder:text-zinc-600 text-base sm:w-40 sm:border-l sm:border-white/10 sm:pl-4"
        />
        <button
          data-testid="waitlist-submit"
          disabled={loading}
          type="submit"
          className="bg-adrenaline text-white px-6 py-4 text-heading uppercase tracking-[0.2em] text-sm hover:bg-red-600 transition-colors flex items-center gap-2 justify-center btn-glow disabled:opacity-40"
        >
          {loading ? "…" : <>Join Drop List <ArrowRight size={16} /></>}
        </button>
      </div>
      {error && <div data-testid="waitlist-error" className="text-adrenaline text-mono text-xs mt-3 uppercase tracking-widest">{error}</div>}
      <p className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600 mt-3">We email first. No spam. Limited to drop notices.</p>
    </form>
  );
}
